"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ErrorPage", {
  enumerable: true,
  get: function get() {
    return _errorDestination.default;
  }
});

var _errorDestination = _interopRequireDefault(require("./error-destination"));